<template>
  <div>
    <form class="space-y-6" @submit.prevent="forgotPassword()">
      <div>
        <label for="email" class="block text-sm font-medium text-gray-700"> Email address </label>
        <div class="mt-1">
          <input v-model="form.email" id="email" name="email" type="email" autocomplete="email" required="" inputmode="email"
                 class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-cerulean-500 focus:border-cerulean-500 sm:text-sm"/>
        </div>
      </div>

      <FormButton size="full" color="gradient" type="submit" :loading="form.loading">Send Reset Link</FormButton>
    </form>
    <div class="-mx-4 mt-12 -mb-8 flex items-center justify-between rounded-b-lg bg-slate-50 px-4 py-6 text-sm font-medium text-slate-800 sm:-mx-10 sm:px-6">
      <span>
        You can also
        <RouterLink to="/login" class="text-primary-600 hover:text-primary-700 hover:underline">Log In</RouterLink>
        or
        <RouterLink to="/create-account" class="text-primary-600 hover:text-primary-700 hover:underline">Sign Up</RouterLink>
      </span>
    </div>
  </div>
</template>

<script setup>
import {useAccountStore} from "../stores/AccountStore";
import {reactive} from "vue";
import {redirectToDashboardIfAuthenticated} from "../helpers/Redirects";
import {useRouter} from "vue-router";
import FormButton from "../components/FormButton.vue";

const accountStore = useAccountStore();
const router = useRouter();

const form = reactive({
  email: "",
  loading: false,
});

const forgotPassword = () => {
  if(form.loading) return;
  form.loading = true;
  accountStore
    .forgotPassword(form.email)
    .then(() => {
      toast.success("Password reset link sent to your email address.");
      router.push({path: "/login"});
    })
    .finally(() => form.loading = false);
};

redirectToDashboardIfAuthenticated(router);
</script>
